import { createSelectorFactory, defaultMemoize } from '@ngrx/store';
import isEqual from 'lodash-es/isEqual';

declare type AnyFn = (...args: any[]) => any;
function isEqualMemoized(projectionFn: AnyFn) {
    return defaultMemoize(projectionFn, isEqual);
}

export const createIsEqualSelector = createSelectorFactory(isEqualMemoized);
